/**
 * @components retrievePassword
 * @author 陈恩浩
 */

import React, { Component } from 'react'
import { Input, Select } from 'antd'
import './index.scss'
import { postRetrievePassword } from 'src/apis/user'
import { withTranslation } from 'react-i18next'

const { Option } = Select

@withTranslation()
class Retrieve extends Component {
  constructor(props) {
    super(props)
    this.state = {
      time: 0,
      phone: '',
      pwd: '',
      vertical: '',
    }
  }

  componentDidMount() { }

  countDown = () => {
    let time = 60
    let timer = setInterval(() => {
      if (time > 0) {
        time -= 1
        this.setState({ time })
      } else {
        clearInterval(timer)
      }
    }, 1000)
  }

  handleClickVertical = () => {
    let { time } = this.state
    if (time === 0) {
      this.countDown()
    } else {
      return
    }
  }

  handleRetrieve = () => {
    let { phone, pwd, vertical } = this.state
    if (phone && pwd && vertical) {
      postRetrievePassword({ phone, pwd, vertical }).then((res) => {
        console.log(res)
      })
    }
  }

  handlePhone = (e) => {
    // console.log(e.target.value)
    let phone = e.target.value
    this.setState({ phone })
  }

  handleVertical = (e) => {
    // console.log(e.target.value)
    let vertical = e.target.value
    this.setState({ vertical })
  }

  handlePassword = (e) => {
    // console.log(e.target.value)
    let pwd = e.target.value
    this.setState({ pwd })
  }

  onFinish = (values) => {
    console.log('Received values of form: ', values)
  }

  render() {
    let { t } = this.props;
    const options = [
      {
        value: 'US+1',
        label: 'US+1',
      },
      {
        value: 'US+21',
        label: 'US+21',
      },
    ]
    return (
      <div className="login">
        <div className="login-title">找回密码</div>
        <div className="login-layout">
          <div className="text">手机号/Phone</div>
          <Select defaultValue="CN+86">
            {options.map((item, index) => (
              <Option key={'select-' + index} value={item.value}>
                {item.label}
              </Option>
            ))}
          </Select>
          <Input maxLength="11" onChange={this.handlePhone}></Input>
        </div>
        <div className="login-layout-extra"></div>
        <div className="login-layout">
          <div className="text">验证码/Code</div>
          <Input maxLength="6" onChange={this.handleVertical} />
          <div className="vertical">{t('popout:found_verify')}</div>
        </div>
        <div className="login-layout-extra"></div>
        <div className="login-layout">
          <div className="text">新密码/New password</div>
          <Input.Password
            maxLength="32"
            onChange={this.handlePassword}
          ></Input.Password>
        </div>
        <div className="login-layout-extra">
          <p>{t('popout:found_tip')}</p>
        </div>
        <div className="login-button" onClick={this.handleRetrieve}>
          完成并登录
        </div>
        <div className="login-layout-extra">
          <div className="extra-left">
            <span className="extra-right__password">{t('popout:found_password')}</span>
          </div>
          <div className="extra-right">
            <span className="extra-right__password">{t('popout:found_register')}</span>
          </div>
        </div>
      </div>
    )
  }
}

export default Retrieve
